import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { manageTranscriptionSchema } from "../../../../utils/mainTabs/manage/createShotclassSchema";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import { FaSave } from "react-icons/fa";
import Modal from "../../../Common/Modal/Modal";
import { useSelector } from "react-redux";
import classes from "./TransciptTagsTable.module.scss";
import TranscriptAddTag from "../TranscriptAddTag/TranscriptAddTag";
import { FormattedMessage } from "react-intl";

const TransciptTagsTable = ({
  data,
  shotclassName,
  handleSubmitData,
  shotclassType,
}) => {
  const [submitData, setSubmitData] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);

  const manageState = useSelector((state) => state.manageReducer);
  const { addTranscribeTagLoader } = manageState;

  const methods = useForm({
    defaultValues: { TransciptTagList: [...data] },
    resolver: yupResolver(manageTranscriptionSchema),
  });
  const {
    handleSubmit,
    formState: { errors, isDirty },
    control,
    setFocus,
  } = methods;
  const { fields: transciptTagFields } = useFieldArray({
    control,
    name: "TransciptTagList",
  });
  const onSubmit = (data) => {
    setSubmitData(data);
    setConfirmModal(true);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <table className={classes.form__table}>
          <thead className={classes.form__table__head}>
            <tr className={classes.form__table__head__row}>
              <th>
                {shotclassType === 1 ? (
                  <div>
                    Time Stamp
                    <br />
                    <small>(Start Time - End Time)</small>
                  </div>
                ) : shotclassType === 3 ? (
                  "Slide Number"
                ) : (
                  "Page Number"
                )}
              </th>
              <th>Tag</th>
              <th>
                <div>
                  Transcript
                  {isDirty && (
                    <Button
                      label={<FormattedMessage id="P_SAVE_TXT" />}
                      height="3"
                      width="10"
                      icon={FaSave}
                      type={"submit"}
                      onClick={() => setConfirmModal(true)}
                      light
                      isHover
                    />
                  )}
                </div>
              </th>
            </tr>
          </thead>
          <tbody className={classes.form__table__body}>
            {transciptTagFields?.map((row, index) => {
              return (
                <tr key={row?.section_id}>
                  <td>
                    {shotclassType === 1
                      ? row?.start_time + " - " + row?.end_time
                      : shotclassType === 3
                      ? row?.slide_no
                      : row?.page_no}
                  </td>
                  <td>
                    <TranscriptAddTag
                      index={index}
                      isActive={!!row?.section_tags}
                      setFocus={setFocus}
                      error={
                        errors?.TransciptTagList?.[index]?.section_tags?.message
                      }
                    />
                  </td>
                  <td>
                    <Input
                      name={`TransciptTagList.${index}.content_body`}
                      error={
                        errors?.TransciptTagList?.[index]?.content_body?.message
                      }
                      type="textarea"
                      width="26"
                      height="5.2"
                      gap="0"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Modal
          isOpen={confirmModal}
          heading={shotclassName}
          toggle={() => setConfirmModal(false)}
          handleSubmit={() => {
            handleSubmitData(submitData, setConfirmModal);
          }}
          buttonLabel1={<FormattedMessage id="YES_TEXT" />}
          buttonLabel2={<FormattedMessage id="NO_TEXT" />}
          width={"50"}
          height={"24"}
          loading={addTranscribeTagLoader}
        >
          <div className={classes.form__confirmModal}>
            <div className={classes.form__confirmModal__text}>
              <FormattedMessage id="CONFIRM_SAVE_TRANSCRIPT" />
            </div>
          </div>
        </Modal>
      </form>
    </FormProvider>
  );
};

export default TransciptTagsTable;
